import styled from 'styled-components';
import { Button, Heading, Text, tombac } from 'tombac';
import { CancelIcon } from 'tombac-icons';
import { ProductLogo } from "./ProductLogo";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CloseIcon = styled.div.attrs(() => ({
  children: /*#__PURE__*/_jsx(CancelIcon, {})
})).withConfig({
  displayName: "ProductModalHeader__CloseIcon"
})(["& > svg{height:", ";width:", ";}"], tombac.unit(24), tombac.unit(24));
export const Header = styled.div.withConfig({
  displayName: "ProductModalHeader__Header"
})(["display:grid;gap:", ";grid-template-areas:'logo title close' 'logo subtitle .';grid-template-columns:min-content auto min-content;margin-left:", ";padding:", ";"], tombac.space(1, 3), tombac.space(-3), tombac.space(3, 4));
const Logo = styled.div.withConfig({
  displayName: "ProductModalHeader__Logo"
})(["grid-area:logo;margin-left:", ";& > svg{height:48px;width:48px;}"], tombac.space(3));
export const ProductModalHeader = ({
  icon,
  onRequestClose,
  productId,
  subtitle,
  title
}) => /*#__PURE__*/_jsxs(Header, {
  "data-sentry-element": "Header",
  "data-sentry-component": "ProductModalHeader",
  "data-sentry-source-file": "ProductModalHeader.tsx",
  children: [(productId || icon) && /*#__PURE__*/_jsxs(Logo, {
    children: [productId && /*#__PURE__*/_jsx(ProductLogo, {
      productId: productId
    }), icon]
  }), /*#__PURE__*/_jsx(Heading, {
    $gridArea: "title",
    as: "div",
    level: 4,
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "ProductModalHeader.tsx",
    "data-sentry-element": "Heading",
    children: title
  }), subtitle && /*#__PURE__*/_jsx(Text, {
    $gridArea: "subtitle",
    as: "div",
    children: subtitle
  }), /*#__PURE__*/_jsx(Button, {
    $gridArea: "close",
    onClick: onRequestClose,
    prepend: /*#__PURE__*/_jsx(CloseIcon, {}),
    shape: "circle",
    size: "xs",
    variant: "flat",
    "data-sentry-element": "Button",
    "data-sentry-source-file": "ProductModalHeader.tsx",
    "data-sentry-element": "Button"
  })]
});